import { diffWordsWithSpace } from "diff";

export const DELETE = -1;
export const EQUAL = 0;
export const INSERT = 1;

export function renderTextDiff(container, beforeText, afterText) {
  const diffs = diffWordsWithSpace(beforeText, afterText).map((part) => [
    part.added ? INSERT : part.removed ? DELETE : EQUAL,
    part.value,
  ]);

  const beforeClassName = container.getAttribute("data-before-class-name");
  const afterClassName = container.getAttribute("data-after-class-name");
  const deletedClassName = container.getAttribute("data-deleted-class-name");
  const insertedClassName = container.getAttribute("data-inserted-class-name");

  const before = document.createElement("div");
  before.className = beforeClassName;
  diffs.forEach(([type, text]) => {
    if (type === DELETE || type === EQUAL) {
      const span = document.createElement("span");
      if (type === DELETE) span.className = deletedClassName;
      span.textContent = text;
      before.appendChild(span);
    }
  });

  const after = document.createElement("div");
  after.className = afterClassName;
  diffs.forEach(([type, text]) => {
    if (type === INSERT || type === EQUAL) {
      const span = document.createElement("span");
      if (type === INSERT) span.className = insertedClassName;
      span.textContent = text;
      after.appendChild(span);
    }
  });

  const separator = document.createElement("div");
  separator.className = "text-diff__separator";
  separator.textContent = "→";

  container.innerHTML = "";
  container.appendChild(before);
  container.appendChild(separator);
  container.appendChild(after);
}
